import React from 'react';

import PropTypes from 'prop-types';
import {useSelector} from 'react-redux';

import {UploadMediaWithThumbnail} from '..';
import {getIsBasicEditingEnabled} from '../../../utils/editingContent';

const UploadCourseMediaWithThumbnail = ({blockMLSImageRemoval, ...props}) => {
  const courseId = useSelector((state) => state.moduleActivity.get('courseId'));
  const courses = useSelector((state) => state.course.get('courses'));
  const course = courses.find((c) => c.get('id') === courseId)?.toJS();

  const isBasicEditingEnabled = getIsBasicEditingEnabled({course});
  const isRemovingEnabled =
    !(blockMLSImageRemoval && course.isMultiLanguage) && isBasicEditingEnabled;

  return (
    <UploadMediaWithThumbnail
      isAddingEnabled={isBasicEditingEnabled}
      isRemovingEnabled={isRemovingEnabled}
      {...props}
    />
  );
};

UploadCourseMediaWithThumbnail.propTypes = {
  // This is used to prevent the removal of the content key from all languages
  blockMLSImageRemoval: PropTypes.bool,
};
export default UploadCourseMediaWithThumbnail;
